import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEntitlements } from '../store/EntitlementStore';
import './TaxEntryPage.css';

/**
 * Tax entry point page.
 * Handles handoff to Tax app or shows upsell.
 */
export const TaxEntryPage = () => {
  const navigate = useNavigate();
  const { hasFeature, loading } = useEntitlements();
  const taxEnabled = hasFeature('enable_tax');

  // Tax app URL (configure via environment variable)
  const TAX_APP_URL = process.env.REACT_APP_TAX_APP_URL || 'https://tax.portalr.com';

  const handleGoToTax = () => {
    if (taxEnabled) {
      // Redirect to Tax app
      window.location.href = TAX_APP_URL;
    } else {
      // Navigate to subscriptions to enable
      navigate('/settings/subscriptions', { state: { highlightModule: 'tax' } });
    }
  };

  if (loading) {
    return (
      <div className="tax-entry-loading">
        <div className="loading-spinner">Loading...</div>
      </div>
    );
  }

  if (taxEnabled) {
    return (
      <div className="tax-entry-page">
        <div className="tax-entry-card">
          <div className="tax-entry-icon">📋</div>
          <h1>Portalr Tax</h1>
          <p>You're all set! Redirecting to Portalr Tax...</p>
          <button className="btn btn-primary" onClick={handleGoToTax}>
            Go to Portalr Tax
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="tax-entry-page">
      <div className="tax-entry-card tax-entry-upsell">
        <div className="tax-entry-icon">🔒</div>
        <h1>Portalr Tax is Locked</h1>
        <p>
          Unlock Portalr Tax to access powerful tax management and compliance features.
        </p>
        <ul className="tax-features-list">
          <li>✓ Tax form management</li>
          <li>✓ Document storage</li>
          <li>✓ E-signature workflows</li>
          <li>✓ Audit trail tracking</li>
        </ul>
        <button className="btn btn-primary btn-large" onClick={handleGoToTax}>
          Enable Portalr Tax
        </button>
        <p className="tax-entry-note">
          You'll be redirected to manage your subscription and enable the Tax module.
        </p>
      </div>
    </div>
  );
};

